import { cacheTypes } from "./cache.types";

export const getCacheDataActionObj = ({ convId, conversation, user }) => ({
  type: cacheTypes.CONVS_CACHE_DATA,
  payload: {
    convId,
    conversation,
    user,
  },
});
